(function () {
  var STORAGE_KEY = 'proSignupPopupDismissed';

  function getDismissedKeys() {
    try {
      var raw = sessionStorage.getItem(STORAGE_KEY);
      if (!raw) return [];
      return raw.split('|').filter(function (s) { return s.length > 0; });
    } catch (e) {
      return [];
    }
  }

  function markDismissed(pageKey) {
    if (!pageKey) return;
    try {
      var keys = getDismissedKeys();
      if (keys.indexOf(pageKey) === -1) {
        keys.push(pageKey);
        sessionStorage.setItem(STORAGE_KEY, keys.join('|'));
      }
    } catch (e) { /* sessionStorage unavailable — silent */ }
  }

  function isDismissed(pageKey) {
    if (!pageKey) return false;
    return getDismissedKeys().indexOf(pageKey) !== -1;
  }

  function getPopup() {
    return document.getElementById('ProSignupPopup');
  }

  function show(popup) {
    popup.classList.add('is-visible');
    popup.setAttribute('aria-hidden', 'false');
    document.documentElement.style.overflow = 'hidden';
  }

  function hide(popup) {
    popup.classList.remove('is-visible');
    popup.setAttribute('aria-hidden', 'true');
    document.documentElement.style.overflow = '';
    markDismissed(popup.getAttribute('data-page-key') || '');
  }

  function init() {
    var popup = getPopup();
    if (!popup) return;

    var pageKey = popup.getAttribute('data-page-key') || '';
    if (!pageKey) return;
    if (isDismissed(pageKey)) return;

    var delay = parseInt(popup.getAttribute('data-popup-seconds') || '0', 10);
    if (isNaN(delay) || delay < 0) delay = 0;

    var triggerMode = popup.getAttribute('data-trigger-mode') || 'delay';
    var productSelector = popup.getAttribute('data-product-selector') || '.grid-product, .collection-item';

    var hasShown = false;
    function showOnce() {
      if (hasShown) return;
      hasShown = true;
      show(popup);
    }

    function scheduleShow() {
      setTimeout(showOnce, delay * 1000);
    }

    if (triggerMode === 'scroll-into-section' && 'IntersectionObserver' in window) {
      // Wait until the configured product section is in the viewport, then start the delay.
      var target = document.querySelector(productSelector);

      if (!target) {
        // No product section on the page — fall back to a simple delay so the popup still surfaces.
        scheduleShow();
      } else {
        var observer = new IntersectionObserver(function (entries) {
          for (var i = 0; i < entries.length; i++) {
            if (entries[i].isIntersecting) {
              observer.disconnect();
              scheduleShow();
              break;
            }
          }
        }, { threshold: 0.15 });
        observer.observe(target);
      }
    } else {
      // Product / collection / custom pages: just delay from page load.
      scheduleShow();
    }

    // Close button
    var closeBtn = popup.querySelector('.pro-signup-close');
    if (closeBtn) {
      closeBtn.addEventListener('click', function () { hide(popup); });
    }

    // Dismiss buttons
    var dismissBtns = popup.querySelectorAll('.pro-signup-dismiss');
    dismissBtns.forEach(function (btn) {
      btn.addEventListener('click', function () { hide(popup); });
    });

    // "Submit my license" — closes this and opens the existing cosmo-license-popup
    var triggerCosmoBtns = popup.querySelectorAll('.pro-signup-trigger-cosmo');
    triggerCosmoBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        hide(popup);
        if (typeof window.showCosmoPopup === 'function') {
          setTimeout(window.showCosmoPopup, 250);
        }
      });
    });

    // Click outside to dismiss
    popup.addEventListener('click', function (e) {
      if (e.target === popup) hide(popup);
    });

    // Escape key
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && popup.classList.contains('is-visible')) {
        hide(popup);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
